import { createApp } from './main'

const { app, router } = createApp()

// wait until router is ready before mounting to ensure hydration match
router.isReady().then(() => {
  const disableSSR = router.currentRoute.value.matched.some((record) => record.meta.ssr === false)
  if (disableSSR) {
    // The server rendered only the app shell for this route; clear it and do
    // a fresh client mount instead of hydrating against mismatched markup.
    const container = document.getElementById('app')
    if (container) container.innerHTML = ''

    // Also drop the server-injected head teleport (meta tags, config script),
    // otherwise the fresh mount appends a duplicate set.
    const head = document.head
    let inTeleport = false
    for (const node of Array.from(head.childNodes)) {
      const isComment = node.nodeType === Node.COMMENT_NODE
      if (isComment && node.textContent === 'teleport start anchor') inTeleport = true
      const remove = inTeleport
      if (isComment && node.textContent === 'teleport anchor') inTeleport = false
      if (remove) head.removeChild(node)
    }
  }
  app.mount('#app')
})
